import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card, CardFooter } from '@components/card/card';
import { CardBody, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch } from '@store/hooks';
import { addAllocateTransactions } from '@store/INV/Transactions/InvAllocate/InvAllocateSlice';
import { useNavigate } from 'react-router-dom';
import { TreeSelect } from 'antd';
import Loading from '@components/Shared/Loader/Loading';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import NeatixModal from '@components/Modal/NeatixModal';
import { useEffect, useState } from 'react';
import useGetTransactionTypesList from '@hooks/INV/TransactionTypes/useGetTransactionTypesList';
import AllocateLines from './AllocateLines';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { AddAllocatTransactionsSchema } from '@pages/ValidationForm/validationSchema';

const Add = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const { InventoryOptions, loading, error } = useGetInventoryWithPermission();
  const { TreeSubInventoryData, loading: loading1, error: error1 } = useGetSubinventoryList();
  const { OptionsTransactionTypes, loading: loading2, error: error2 } = useGetTransactionTypesList();
  const { OperatingUnitOptions, loading: loading3, error: error3 } = useGetOperatingUnitWithPermission();

  //#region Formik
  const formik = useFormik({
    initialValues: {
      code: 'ALC', // تخصيص - حجز
      // transactionDate: '',
      transactionDate: new Date().toISOString().split('T')[0],
      description: '',
      branchId: '',
      transactionAmount: 0,
      referenceType: '',
      referenceId: '',
      supplierId: null,
      customerId: null,
      personId: null,
      subInventoryId: null,
      inventoryId: '',
      address: '',
      note: '',
      transactionYear: 0,
      materialTransactionsLineList: [
        {
          id: null, //
          transactionItemId: null,
          transactionUom: '',
          unitPrice: 0,
          transactionQuantityIn: 0,
          transactionQuantityOut: 0,
          lotId: '',
          referenceIdMaster: '',
          referenceIdLine: ''
        }
      ]
    },
    enableReinitialize: true,
    validationSchema: AddAllocatTransactionsSchema(t),
    onSubmit: values => {
      dispatch(
        addAllocateTransactions({
          // code: values.code,
          code: 'ALC',
          transactionDate: values.transactionDate,
          description: values.description,
          branchId: values.branchId,
          transactionAmount: 0,
          referenceType: values.code,
          referenceId: values.referenceId || null,
          supplierId: values.supplierId || null,
          customerId: values.customerId || null,
          personId: values.personId || null,
          inventoryId: values.inventoryId,
          address: values.address,
          note: values.note,
          transactionYear: 0,
          subInventoryId: values.subInventoryId,
          materialTransactionsLineList: formik.values.materialTransactionsLineList?.map(item => ({
            transactionItemId: item.transactionItemId,
            transactionUom: item.transactionUom,
            unitPrice: item.unitPrice, // item.price
            transactionQuantityIn: item.transactionQuantityIn,
            transactionQuantityOut: 0,
            lotId: item.lotId || null,
            inventoryId: null,
            referenceIdMaster: null,
            referenceIdLine: null,
            transactionTypeId: null,
            equivalent: 0,
            expensesAmount: 0
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          // debugger;
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            Navigate('/INV/Transactions/Allocate', { replace: true });
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;
  //#endregion

  //____________________________
  // تحديد المخزن الفرعي الأول تلقائيًا عند تغيير المخزن الرئيسي أو عند تحميل البيانات
  useEffect(() => {
    if (values.inventoryId && TreeSubInventoryData?.length > 0) {
      // تصفية المخازن الفرعية التي تتبع المخزن الرئيسي المحدد
      const filteredSubInventories = TreeSubInventoryData.filter(f => f.parentId === values.inventoryId);

      // إذا لم يكن هناك مخزن فرعي محدد حاليًا، اختر الأول
      if (!values.subInventoryId && filteredSubInventories.length > 0) {
        formik.setFieldValue('subInventoryId', filteredSubInventories[0].value);
      }
    }
  }, [values.inventoryId, TreeSubInventoryData]);

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
           link: '/INV/HomePage'
          },
          {
            name: 'حجز أصناف',
            link: '/INV/Transactions/UpdateCost'
          },
          {
            name: 'حجز جديد',
            link: null
          }
        ]}
        PageName='حجز جديد'
        subtitle={InventoryOptions?.find((f: any) => f.value === values.inventoryId)?.label}
      />

      <Card>
        <Loading loading={loading || loading1 || loading2 || loading3} error={error || error1 || error2 || error3}>
          <Form onSubmit={formik.handleSubmit}>
            <CardBody>
              <div className='row '>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('التاريـخ')}</label>
                    <Form.Control
                      className='form-control  text-center'
                      type='date'
                      name='transactionDate'
                      onChange={formikhandleChange}
                      value={values.transactionDate || ''}
                      // isInvalid={!!(touched.transactionDate && errors.transactionDate)}
                    />
                    <div className='text-danger small'>{touched.transactionDate && errors.transactionDate}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الوحدة التشغيليـة')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading3}
                      isSearchable
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>{touched.branchId && errors.branchId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('المخزن')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading}
                      isSearchable={true}
                      isClearable
                      options={InventoryOptions}
                      value={InventoryOptions?.find((f: any) => f.value === values.inventoryId)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>{formik.touched.inventoryId && formik.errors.inventoryId}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('المخزن الفرعي')}</label>
                    <TreeSelect
                      loading={loading1}
                      showSearch
                      className='w-100'
                      treeLine
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      allowClear
                      treeDefaultExpandAll={false}
                      value={values.subInventoryId}
                      onChange={(option: any) => {
                        formik.setFieldValue('subInventoryId', option === null ? null : option);
                      }}
                      treeData={TreeSubInventoryData?.filter(f => f.parentId === values.inventoryId)}
                      treeNodeFilterProp='title'
                    />
                    <div className='text-danger small'>
                      {formik.touched.subInventoryId && formik.errors.subInventoryId}
                    </div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('نوع الحركة')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading2}
                      isSearchable={true}
                      isClearable
                      options={OptionsTransactionTypes}
                      value={OptionsTransactionTypes.find(f => f.value === values.code)}
                      onChange={(option: any) => {
                        formik.setFieldValue('code', option === null ? null : option.value);
                      }}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger small'>{formik.touched.code && formik.errors.code}</div>
                  </div>
                </div>

                <div className='col-lg-9'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      autoComplete='off'
                      className='form-control'
                      as='textarea'
                      rows={1}
                      name='description'
                      onChange={formik.handleChange}
                      value={values.description}
                    />
                  </div>
                </div>
              </div>
            </CardBody>
            <CardFooter className='shadow-sm px-0 bg-secondary bg-opacity-10'>
              {values.inventoryId && <AllocateLines formik={formik} />}
            </CardFooter>

            <div className='text-center mt-4'>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                )}
                {t('Add')}
              </button>
              <button type='button' className='btn btn-lg  me-1 btn-default mb-1' onClick={() => Navigate(-1)}>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </Form>
        </Loading>
      </Card>

      <Modal show={showModal} backdrop='static' keyboard={false} centered className='modal-selection-theme'>
        {/* العنوان */}
        <Modal.Header className='bg-theme bg-opacity-30 text-white py-3'>
          <Modal.Title className='text-center w-100 h5'>
            <i className='fas fa-warehouse me-2'></i>
            {t('اختيار الوحدة التشغيلية والمخزن ونوع الحركة')}
          </Modal.Title>
        </Modal.Header>

        {/* الجسم */}
        <Modal.Body className='p-4'>
          <div className='text-center mb-4'>
            <div
              className='bg-secondary bg-opacity-35 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
              style={{ width: '70px', height: '70px' }}
            >
              <i className='fas fa-clipboard-list fs-2 text-theme'></i>
            </div>
            <p className='text-muted mb-0'>{t('يجب اختيار الوحدة التشغيلية والمخزن ونوع الحركة قبل المتابعة')}</p>
          </div>

          <div className='row'>
            {/* وحدة التشغيل */}
            <div className='col-12 mb-4'>
              <label className='form-label fw-bold'>{t('الوحدة التشغيليـة')}</label>
              <div className='input-group'>
                <span className='input-group-text bg-secondary bg-opacity-35 border-end-0'>
                  <i className='fas fa-building text-theme'></i>
                </span>
                <Select
                  classNamePrefix='react-select'
                  isSearchable
                  isClearable
                  options={OperatingUnitOptions}
                  value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
                  onChange={(option: any) => {
                    formik.setFieldValue('branchId', option?.value || '');
                    formik.setFieldValue('inventoryId', '');
                    formik.setFieldValue('code', '');
                  }}
                  placeholder={t('إختر الوحدة التشغيلية')}
                  className='flex-grow-1'
                />
              </div>
              {!formik.values.branchId && (
                <div className='form-text text-info mt-2'>
                  <i className='fas fa-info-circle me-1'></i>
                  {t('اختر الوحدة التشغيلية أولاً لتمكين اختيار المخزن')}
                </div>
              )}
            </div>

            {/* المخزن */}
            <div className='col-12 mb-4'>
              <label className='form-label fw-bold'>{t('المخزن')}</label>
              <div className='input-group'>
                <span className='input-group-text bg-secondary bg-opacity-35 border-end-0'>
                  <i className='fas fa-boxes text-theme'></i>
                </span>
                <Select
                  classNamePrefix='react-select'
                  isSearchable
                  isClearable
                  options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.branchId)}
                  value={
                    formik.values.inventoryId &&
                    InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)
                  }
                  onChange={(option: any) => formik.setFieldValue('inventoryId', option?.value || '')}
                  placeholder={t('إختر المخزن')}
                  isDisabled={!formik.values.branchId}
                  className='flex-grow-1'
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        {/* الأزرار */}
        <Modal.Footer className='justify-content-center border-top-0 pt-0'>
          <button
            className='btn btn-outline-secondary btn-lg px-4 py-2 me-3'
            onClick={() => Navigate('/INV/Transactions/Allocate', { replace: true })}
          >
            <i className='fas fa-times me-2'></i>
            {t('إلغاء')}
          </button>
          <button
            className='btn btn-theme btn-lg px-5 py-2'
            onClick={() => setShowModal(false)}
            disabled={!formik.values.branchId || !formik.values.inventoryId}
          >
            <i className='fas fa-check-circle me-2'></i>
            {t('استمرار')}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Add;

// <NeatixModal
//       show={showModal}
//       setShow={setShowModal}
//       size='md'
//       bodyClassName='p-0'
//       showHeader={false}
//       keyboard={false}
//       backdrop={true}
//     >
//       <Card>
//         <CardBody>
//           <div className='row'>
//              <div className='col-lg-12'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('الوحدة التشغيليـة')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   isLoading={loading3}
//                   isSearchable
//                   isClearable
//                   options={OperatingUnitOptions}
//                   value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId)}
//                   onChange={option => {
//                     formik.setFieldValue('inventoryId', '');
//                     formik.setFieldValue('branchId', option?.value || '');
//                   }}
//                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 />
//               </div>
//             </div>

//             <div className='col-lg-12'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('المخزن')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   isLoading={loading}
//                   isSearchable
//                   isClearable
//                   options={InventoryOptions?.filter((f: any) => f.operatingUnitId === formik.values.branchId)}
//                   value={
//                     formik.values.inventoryId &&
//                     InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId)
//                   }
//                   onChange={option => formik.setFieldValue('inventoryId', option?.value || null)}
//                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                 />
//               </div>
//             </div>
//           </div>
//           <div className='row'>
//             <div className='col-6'>
//               <button
//                 type='button'
//                 className='btn btn-lg btn-theme  w-100 rounded-0'
//                 // onClick={handleSubmitModal}
//                 onClick={() => setShowModal(false)}
//                 disabled={!formik.values.branchId || !formik.values.inventoryId}
//               >
//                 <i className='fas fa-lg fa-fw me-2 fa-check-circle'></i>
//                 {t('إختيار')}
//               </button>
//             </div>
//             <div className='col-6'>
//               <button
//                 type='button'
//                 className='btn btn-lg  btn-default  w-100 rounded-0'
//                 onClick={() => Navigate('/INV/Transactions/Allocate', { replace: true })}
//               >
//                 <i className='fas fa-times-circle fa-fw me-1'></i> {t('Cancel')}
//               </button>
//             </div>
//           </div>
//         </CardBody>
//       </Card>
//     </NeatixModal>
